// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';
import type { Dispatch } from 'redux';

import { notifyDanger, notifySuccess } from '@gandi/notifications';
import {
  selectOneOrganization,
  fetchOneOrganization,
} from '@gandi/redux-organization';
import { selectCurrentId } from '@gandi/redux-sharing';
import { withTranslator } from '@gandi/translate';

import { withRouter } from 'src/helpers/withRouter';

import type { FullState } from '../../../types';
import { editCustomer, selectIsEditingCustomer } from '../modules/customers';

import Presenter from './components/Presenter';

import type {
  PresenterProps,
  PresenterStateProps,
  PresenterDispatchProps,
} from './components/Presenter';

const mapStateToProps = (
  state: FullState,
  ownProps: Partial<PresenterProps>,
): PresenterStateProps => ({
  currentOrganizationId: selectCurrentId(state),
  // $FlowFixMe[incompatible-use]
  isEditingCustomer: selectIsEditingCustomer(state, ownProps.params.customerId),

  profile:
    // the customer is loaded as an organization
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[incompatible-use]
    selectOneOrganization(state, ownProps.params.customerId),
});

// $FlowFixMe[missing-type-arg]
const mapActionsToProps = (dispatch: Dispatch): PresenterDispatchProps => ({
  editCustomer: (...args) => dispatch(editCustomer(...args)),
  fetchOneOrganization: (...args: any) =>
    dispatch(fetchOneOrganization(...args)),
  notifyDanger: (...args) => dispatch(notifyDanger(...args)),
  notifySuccess: (...args) => dispatch(notifySuccess(...args)),
});

export default (compose(
  withRouter,
  withTranslator({ propsNamespace: 'translator' }),
  connect(mapStateToProps, mapActionsToProps),
)(Presenter): React.ComponentType<{}>);
